import React from 'react'
import { useMobileContext } from '../../Context/ContextProvider'
import NewSites2024 from './NewSites2024'
import SitesMobile from './SitesMobile'

interface Props {
    classes: {
        cardTitleWhite: string;
        formControl: string;
        cardCategoryWhite: string;
    };
    history: {
        goBack: () => void;
    };
    location: {
        state: {
            serial: number | null
        };

    };
}

const SitesWrapper: React.FC<Props> = (props) => {
    const isMobile = useMobileContext()
    return isMobile ? <SitesMobile {...props} /> : <NewSites2024 {...props} />
}
export default SitesWrapper